import { getCandyHub } from "../Forms/Sentry/InitializeSentry";

export const isBrowser = typeof window !== "undefined";

export function isDOMRectInView(rect: DOMRect | undefined): boolean {
    return rect != undefined && rect.top >= 0 && rect.left >= 0 && rect.bottom <= document.documentElement.clientHeight;
}

export function tryScrollIntoViewWithFallback(element: Element, options: ScrollIntoViewOptions) {
    const getFallbackOptions = () => ({
        ...options,
        ...{
            block: options.block === "center" ? "start" : options.block,
            inline: options.inline === "center" ? "start" : options.inline,
        },
    });
    const sentryHub = getCandyHub();
    try {
        element.scrollIntoView(options);
    } catch (error) {
        sentryHub.captureException(error);
        element.scrollIntoView(getFallbackOptions());
    }
}
